import { useLayoutEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { CustomerProvider } from "../pages/panel/e-commerce/customer/CustomerContext";

import CategoryHome from "../pages/panel/e-commerce/category/index";
import EcomCustomerDetails from "../pages/panel/e-commerce/customer/CustomerDetails";
import EcomCustomer from "../pages/panel/e-commerce/customer/CustomerList";
import EcomDashboard from "../pages/panel/e-commerce/index";
import EcomIntegration from "../pages/panel/e-commerce/integration/Integration";
import EcomProducts from "../pages/panel/e-commerce/product/ProductList";
import EcomSettings from "../pages/panel/e-commerce/settings/Settings";
import EcomSupport from "../pages/panel/e-commerce/support/Messages";

import BlogsList from "../pages/panel/e-commerce/blogs";
import AddBlog from "../pages/panel/e-commerce/blogs/add-blog";






import Error404Classic from "../pages/error/404-classic";
import Error404Modern from "../pages/error/404-modern";
import Error504Classic from "../pages/error/504-classic";
import Error504Modern from "../pages/error/504-modern";

import ForgotPassword from "../pages/auth/ForgotPassword";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Success from "../pages/auth/Success";

import Layout from "../layout/Index";
import LayoutNoSidebar from "../layout/Index-nosidebar";
import ResetPassword from "../pages/auth/ResetPassword";
import EditBlogPage from "../pages/panel/e-commerce/blogs/edit-blog";
import CreateCategoryPage from "../pages/panel/e-commerce/category/AddCategoryPage";
import EditCategoryPage from "../pages/panel/e-commerce/category/EditCategoryPage";
import SubCategoryList from "../pages/panel/e-commerce/category/SubCategory";
import CreateSubCategoryPage from "../pages/panel/e-commerce/category/SubCategory/AddModal";
import EditSubCategoryPage from "../pages/panel/e-commerce/category/SubCategory/EditSubCategoryModal";
import ContactList from "../pages/panel/e-commerce/contacts";
import AddUserPage from "../pages/panel/e-commerce/customer/add-user";
import UpdateUserPage from "../pages/panel/e-commerce/customer/edit-user";
import ReturnList from "../pages/panel/e-commerce/exchangeReturn";
import OrderList from "../pages/panel/e-commerce/order";
import OrderDetails from "../pages/panel/e-commerce/order/order-details";
import PaymentList from "../pages/panel/e-commerce/payments";
import PaymentDetails from "../pages/panel/e-commerce/payments/payment-detail";
import AddProductPage from "../pages/panel/e-commerce/product/add-product";
import EditProductPage from "../pages/panel/e-commerce/product/edit-product";
import PublicReviewList from "../pages/panel/e-commerce/publicReview/index";
import ReviewList from "../pages/panel/e-commerce/review";
import ShippingList from "../pages/panel/e-commerce/shipping";
import ShippingDetails from "../pages/panel/e-commerce/shipping/shipping-detail";
import SliderList from "../pages/panel/e-commerce/sliders";
import SliderForm from "../pages/panel/e-commerce/sliders/add-slider-modal";

const Router = () => {
  const location = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route path={`${process.env.PUBLIC_URL}`} element={<Layout />}>

        <Route index element={<EcomDashboard />}></Route>
        <Route path="orders" element={<OrderList />}></Route>
        <Route path="admin/orders/:id" element={<OrderDetails />}></Route>
        <Route path="payments" element={<PaymentList />}></Route>
        <Route path="admin/payment/:id" element={<PaymentDetails />}></Route>
        <Route path="shipping" element={<ShippingList />}></Route>
        <Route path="admin/shippings/:id" element={<ShippingDetails />}></Route>
        <Route path="products" element={<EcomProducts />}></Route>
        <Route path="exchange" element={<ReturnList />}></Route>
        <Route path="add-product" element={<AddProductPage />}></Route>
        <Route path="edit-product/:productId" element={<EditProductPage />}></Route>
        <Route path="support" element={<EcomSupport />}></Route>
        <Route path="settings" element={<EcomSettings />}></Route>
        <Route path="integration" element={<EcomIntegration />}></Route>
        <Route path="category" element={<CategoryHome />}></Route >
        <Route path="add-category" element={<CreateCategoryPage />}></Route >
        <Route path="edit-category/:id" element={<EditCategoryPage />}></Route >
        <Route path="sub-categories/:id" element={<SubCategoryList />}></Route >
        <Route path="add-sub-category/:id" element={<CreateSubCategoryPage />}></Route >
        <Route path="edit-sub-category/:id/:subId" element={<EditSubCategoryPage />}></Route >
        <Route path="reviews" element={<ReviewList />}></Route >
        <Route path="public-reviews" element={<PublicReviewList />}></Route >
        <Route path="contacts" element={<ContactList />}></Route >
        <Route path="blogs" element={<BlogsList />}></Route >
        <Route path="sliders" element={<SliderList />}></Route >
        <Route path="add-slider" element={<SliderForm />}></Route >
        <Route path="edit-slider/:id" element={<SliderForm />}></Route >
        <Route path="admin/blogs/add" element={<AddBlog />}></Route >
        <Route path="admin/blogs/edit/:id" element={<EditBlogPage />}></Route >
        <Route element={<CustomerProvider />} >
          <Route path="customer" element={<EcomCustomer />}></Route>
          <Route path="add-user" element={<AddUserPage />}></Route>
          <Route path="edit-user/:userId" element={<UpdateUserPage />}></Route>
          <Route path="customer-details/:customerId" element={<EcomCustomerDetails />}></Route>
        </Route>
      </Route>

      <Route path={`${process.env.PUBLIC_URL}`} element={<LayoutNoSidebar />}>
        <Route path="auth-success" element={<Success />}></Route>
        <Route path="auth-reset" element={<ForgotPassword />}></Route>
        <Route path="auth-register" element={<Register />}></Route>
        <Route path="auth-login" element={<Login />}></Route>
        <Route path="auth-reset-password" element={<ResetPassword />}></Route>

        <Route path="errors">
          <Route path="404-modern" element={<Error404Modern />}></Route>
          <Route path="404-classic" element={<Error404Classic />}></Route>
          <Route path="504-modern" element={<Error504Modern />}></Route>
          <Route path="504-classic" element={<Error504Classic />}></Route>
        </Route>
        <Route path="*" element={<Error404Modern />}></Route>
      </Route>
    </Routes>
  );
};
export default Router;
